<template>
  <div class="guide-content">
    <!-- 全部 -->
    <div class="all-tab" v-if="themeActive == 0">
      <div class="card" v-for="item in 6" :key="item">
        <div class="img-info">
          <img :src="src" class="card-img" alt="" />
          <div class="mask">
            <el-button class="ylbtn" @click="previewCW">预览课件</el-button>
            <el-button class="xzbtn" @click="download">下载课件</el-button>
          </div>
        </div>
        <div class="title">{{item.title}}</div>
        <div class="desc">{{item.summary}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    themeActive: Number
  },
  data: () => ({
    src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
  }),
  components: {},
  created() {},
  methods: {
    previewCW() {
      console.log("预览课件");
    },
    download() {
      console.log("下载课件");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./serviceGuide";
</style>
